import { COMPLETED } from '../../common/Types';
import { DailyTaskI } from '../../interfaces/DailyTaskInterface';
import { UserI } from '../../store/interfaces/storeStatesInterface';

export function getLatestUnComTasksFromList(
  taskRefList: DailyTaskI[],
  date: string | Date,
  user: UserI,
  goal_key?: string | null,
  showTask?: boolean | null
) {
  const selectedDate = new Date(date);
  selectedDate.setHours(0, 0, 0, 0);

  const _taskList = taskRefList
    // only goal's task, if [goal_key] is provided
    .filter((_task) => (goal_key ? _task.goal_key === goal_key : true))
    // only user's tasks
    .filter((_task) => _task.user_uid === user.uid)
    // sort by priority
    .sort((a, b) => Number(b.priority) - Number(a.priority))
    // assignation date is more or equal to today
    .filter((_task) => {
      const _taskAsDate = new Date(_task.assignedDate);
      _taskAsDate.setHours(0, 0, 0, 0);

      return (
        // show the lastest task to complete
        showTask ||
        // only show selected date tasks
        (selectedDate.getFullYear() === _taskAsDate.getFullYear() &&
          selectedDate.getMonth() === _taskAsDate.getMonth() &&
          selectedDate.getDate() === _taskAsDate.getDate())
      );
    })
    // tasks ain't completed
    .filter((_task) => _task.taskStatus !== COMPLETED);
  // take only one task in each Goal,
  var _goalKeyList: string[] = [];

  const _uniqTaskByGoalList = _taskList.filter((_task) => {
    const _goalKey = _task.goal_key;
    if (!_goalKeyList.includes(_goalKey)) {
      _goalKeyList = [..._goalKeyList, _goalKey];
      return true;
    } else {
      return false;
    }
  });
  return _uniqTaskByGoalList;
}
